var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.967,
    height: 14.975,
    viewBox: "0 0 19.967 14.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-line",
    transform: "translate(-10.66 -31.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M29.379,31.98H11.908a1.248,1.248,0,0,0-1.248,1.248V45.707a1.248,1.248,0,0,0,1.248,1.248H29.379a1.248,1.248,0,0,0,1.248-1.248V33.228A1.248,1.248,0,0,0,29.379,31.98Zm-.961,13.727H12.944l4.368-4.517-.9-.867-4.5,4.661V34.176l7.756,7.718a1.248,1.248,0,0,0,1.76,0l7.955-7.912V44.9L24.786,40.31l-.88.88ZM12.725,33.228H28.368l-7.824,7.781Z",
    fill: "#9d9d9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGrey);
export default __webpack_public_path__ + "static/media/email-grey.e136e8b0eada473cfb4bd35818be798f.svg";
export { ForwardRef as ReactComponent };